import acgExperienceImg from "@/assets/acg-experience.webp";

const ACGExperience = () => {
  return (
    <section className="py-16 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold text-foreground mb-2">
            The ACG <span className="text-primary">Experience</span>
          </h2>
          <h3 className="text-lg text-muted-foreground">
            Striving to Give Customers the Best Solutions for their Aircon Needs
          </h3>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-10">
          <div className="md:w-1/2 space-y-4 text-sm text-muted-foreground leading-relaxed">
            <p>
              ACG has experienced air conditioning installation technicians who are committed to professionalism and a high level of workmanship. They are trained to deliver complete installation with minimal disruption to your operations. You can expect our friendly technicians to finish work promptly and efficiently, making sure schedules are met and work areas are kept clean and tidy.
            </p>
            <p>
              Occupational Health and Safety (OH&S) is a priority for our company. ACG Airconditioning prudently complies with OH&S procedures and policies to maintain a safe and hazard-free work environment. We also make sure all our technicians are up-to-date with these procedures and policies. As industry leaders, we ensure our air conditioning installation services meet Australian Standards.
            </p>
            <p className="mt-4">
              <a href="/about" className="text-primary hover:underline font-medium text-sm">
                Read more about the ACG story and our commitment to quality
              </a>
            </p>
            <div className="mt-4">
              <div className="inline-flex items-center gap-3 bg-acg-blue text-primary-foreground px-6 py-3 rounded-lg">
                <span className="text-2xl font-black">360°</span>
                <span className="text-sm font-semibold">One-Call Approach</span>
              </div>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center">
            <img
              src={acgExperienceImg}
              alt="ACG Experience - Free Quote, Installation, Training, and After Sales Service"
              className="max-w-full h-auto max-h-[500px] object-contain"
              width={801}
              height={873}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ACGExperience;
